module.exports = __webpack_public_path__ + "static/media/minus.03d87c09.svg";